import type { MatchInitConfig } from "./types";

// Colors for piece designs come from the alkagi token namespace at draw time.
// The fields below are kept for API stability; the renderer reads tokens
// directly via `resolveAlkagiCanvasTokens()` and ignores these values.
const TOKEN_HAN_FILL = "var(--cn-alkagi-stone-white)";
const TOKEN_CHO_FILL = "var(--cn-alkagi-stone-black)";
const TOKEN_STROKE = "var(--cn-alkagi-stone-white-border)";
const TOKEN_HAN_TEXT = "var(--cn-alkagi-stone-black)";
const TOKEN_CHO_TEXT = "var(--cn-alkagi-stone-white)";

export const INIT_CONFIG: MatchInitConfig = {
  title: "Alkagi Client",
  participants: {
    playerOneName: "Player 1 (HAN)",
    playerTwoName: "Player 2 (CHO)",
  },
  board: {
    cols: 9,
    rows: 10,
    boundaryPadding: 0.5,
  },
  dynamics: {
    timeStep: 1 / 60,
    frictionCoefficient: 3.0,
    velocityThreshold: 0.01,
    minImpulseMagnitude: 0.12,
    restitutionCoefficient: 0.8,
    maxSimulationSteps: 600,
  },
  maxTurns: 60,
  pieceTypes: [
    {
      id: "GENERAL",
      name: "General",
      size: 0.46,
      weight: 1.55,
      count: 1,
      design: {
        hanLabel: "漢",
        choLabel: "楚",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["COMMAND_AURA", "LAST_STAND"],
    },
    {
      id: "GUARD",
      name: "Guard",
      size: 0.4,
      weight: 1.3,
      count: 2,
      design: {
        hanLabel: "士",
        choLabel: "士",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["SHIELD_NET", "POSITION_HOLD"],
    },
    {
      id: "ELEPHANT",
      name: "Elephant",
      size: 0.42,
      weight: 1.35,
      count: 2,
      design: {
        hanLabel: "象",
        choLabel: "象",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["RAMPAGE", "FORTIFIED_HIDE"],
    },
    {
      id: "HORSE",
      name: "Horse",
      size: 0.39,
      weight: 1.1,
      count: 2,
      design: {
        hanLabel: "馬",
        choLabel: "馬",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["SWIFT_STEP", "LIGHTWEIGHT"],
    },
    {
      id: "CHARIOT",
      name: "Chariot",
      size: 0.44,
      weight: 1.45,
      count: 2,
      design: {
        hanLabel: "車",
        choLabel: "車",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["BATTERING_RAM", "IRONCLAD"],
    },
    {
      id: "CANNON",
      name: "Cannon",
      size: 0.41,
      weight: 1.2,
      count: 2,
      design: {
        hanLabel: "包",
        choLabel: "包",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["RICOCHET", "SHOCKWAVE"],
    },
    {
      id: "SOLDIER",
      name: "Soldier",
      size: 0.34,
      weight: 0.95,
      count: 5,
      design: {
        hanLabel: "兵",
        choLabel: "卒",
        hanFill: TOKEN_HAN_FILL,
        choFill: TOKEN_CHO_FILL,
        stroke: TOKEN_STROKE,
        hanTextColor: TOKEN_HAN_TEXT,
        choTextColor: TOKEN_CHO_TEXT,
      },
      connectedAugments: ["PHALANX", "MORALE_PUSH"],
    },
  ],
  deploymentPattern: {
    name: "janggi_mirrored_start",
    lanes: [
      {
        pieceTypeId: "CHARIOT",
        columns: [0, 8],
        ownerOneRow: 0,
        ownerTwoRow: 9,
      },
      {
        pieceTypeId: "ELEPHANT",
        columns: [1, 6],
        ownerOneRow: 0,
        ownerTwoRow: 9,
      },
      { pieceTypeId: "HORSE", columns: [2, 7], ownerOneRow: 0, ownerTwoRow: 9 },
      { pieceTypeId: "GUARD", columns: [3, 5], ownerOneRow: 0, ownerTwoRow: 9 },
      { pieceTypeId: "GENERAL", columns: [4], ownerOneRow: 0, ownerTwoRow: 9 },
      {
        pieceTypeId: "CANNON",
        columns: [1, 7],
        ownerOneRow: 2,
        ownerTwoRow: 7,
      },
      {
        pieceTypeId: "SOLDIER",
        columns: [0, 2, 4, 6, 8],
        ownerOneRow: 3,
        ownerTwoRow: 6,
      },
    ],
  },
};
